(() => {
  class BEKSg23Engine {
    constructor(data, options={}) {
      this.data=data||{}; const p=this.data.pricing||{};
      this.options={
        vatPct:Number(options.vatPct ?? p.vatPct ?? 19),
        dealerDiscountPct:Number(options.dealerDiscountPct ?? p.dealerDiscountPct ?? 50),
        targetMarginPct:Number(options.targetMarginPct ?? p.targetMarginPct ?? 40),
        logisticsReserveNet:Number(options.logisticsReserveNet ?? p.logisticsReserveNet ?? 160),
        minimumCustomerGross:Number(options.minimumCustomerGross ?? p.minimumCustomerGross ?? 1490),
        roundingMode:options.roundingMode || p.roundingMode || 'x090',
        satinatoGrossPerSqm:Number(options.satinatoGrossPerSqm ?? p.satinatoGrossPerSqm ?? 69),
        specialColorGross:Number(options.specialColorGross ?? p.specialColorGross ?? 649)
      };
    }
    ceiling(value,bands){const n=Number(value);if(!Number.isFinite(n))return null;return (bands||[]).find(v=>n<=Number(v))??null;}
    roundUpTo90(value){const n=Number(value);return Number.isFinite(n)?Math.ceil((n+10)/100)*100-10:0;}
    applyBaseRound(value){return this.options.roundingMode==='euro'?Math.round(value):this.roundUpTo90(value);}
    candidates(width,height){
      const hBand=this.ceiling(height,this.data.heightBands); if(!hBand)return [];
      const out=[];
      for(const [key,cfg] of Object.entries(this.data.layouts||{})){
        const wBand=this.ceiling(width,cfg.widthBands); if(!wBand)continue;
        const price=Number(cfg.pricesNetList?.[`${wBand}x${hBand}`]); if(!Number.isFinite(price))continue;
        out.push({key,label:cfg.label,rails:Number(cfg.rails),doors:Number(cfg.doors),widthBand:Number(wBand),heightBand:Number(hBand),baseListNet:price,specialColorNetList:Number(cfg.specialColorNetList||0)});
      }
      out.sort((a,b)=>a.baseListNet-b.baseListNet||a.widthBand-b.widthBand||a.doors-b.doors);
      return out;
    }
    resolveLayout(width,height,layout='AUTO'){
      const candidates=this.candidates(width,height); if(!candidates.length)return null;
      const wanted=String(layout||'AUTO').toUpperCase();
      if(wanted==='AUTO')return {...candidates[0],autoSelected:true,compatibleLayouts:candidates};
      const hit=candidates.find(x=>x.key.toUpperCase()===wanted); return hit?{...hit,autoSelected:false,compatibleLayouts:candidates}:null;
    }
    calculate(input={}){
      const width=Number(input.width),height=Number(input.height),layout=String(input.layout||'AUTO').toUpperCase();
      if(!Number.isFinite(width)||!Number.isFinite(height))return {ok:false,error:'INVALID_DIMENSIONS'};
      const resolved=this.resolveLayout(width,height,layout); if(!resolved)return {ok:false,error:'SG23_LAYOUT_NOT_AVAILABLE',requestedWidth:width,requestedHeight:height,layout};
      const glass=String(input.glass||'clear').toLowerCase(); if(!['clear','satinato'].includes(glass))return {ok:false,error:'SG23_GLASS_INVALID'};
      const color=String(input.color||'RAL 7016'); const specialColor=color==='SPECIAL';
      if(!specialColor && !(this.data.standardColors||[]).includes(color))return {ok:false,error:'SG23_COLOR_INVALID'};
      const baseEkNet=resolved.baseListNet*(1-this.options.dealerDiscountPct/100);
      const margin=this.options.targetMarginPct/100;
      const rawBaseGross=((baseEkNet+this.options.logisticsReserveNet)/(1-margin))*(1+this.options.vatPct/100);
      const baseCustomerGross=Math.max(this.options.minimumCustomerGross,this.applyBaseRound(rawBaseGross));
      const areaSqm=width*height/1000000;
      const satinatoGross=glass==='satinato'?Math.round(areaSqm*this.options.satinatoGrossPerSqm):0;
      const satinatoCostNet=glass==='satinato'?areaSqm*28:0;
      const specialColorGross=specialColor?this.options.specialColorGross:0;
      const specialColorCostNet=specialColor?Math.max(Number(this.data.pricing?.specialColorMinimumNetList||310),Number(resolved.specialColorNetList||0)):0;
      const accessories=[]; const catalog=this.data.pricing?.accessories||{};
      if(Boolean(input.lock))accessories.push({code:'LOCK',...catalog.LOCK});
      if(Boolean(input.hook))accessories.push({code:'HOOK',...catalog.HOOK});
      if(Boolean(input.extraGrip))accessories.push({code:'EXTRA_GRIP',...catalog.EXTRA_GRIP});
      const accessoriesGross=accessories.reduce((s,x)=>s+Number(x.customerGross||0),0);
      // Zubehörkosten werden konservativ ohne Händlerrabatt in die Margenprüfung genommen.
      const accessoriesCostNet=accessories.reduce((s,x)=>s+Number(x.netList||0),0);
      const customerGross=Number((baseCustomerGross+satinatoGross+specialColorGross+accessoriesGross).toFixed(2));
      const customerNet=customerGross/(1+this.options.vatPct/100);
      const totalCostNet=baseEkNet+this.options.logisticsReserveNet+satinatoCostNet+specialColorCostNet+accessoriesCostNet;
      const grossProfitNet=customerNet-totalCostNet;
      const rawMarginPct=customerNet>0?grossProfitNet/customerNet*100:0;
      return {
        ok:true,productCode:'SG23',requestedWidth:width,requestedHeight:height,layout:resolved.key,layoutLabel:resolved.label,
        rails:resolved.rails,doors:resolved.doors,widthBand:resolved.widthBand,heightBand:resolved.heightBand,autoSelected:resolved.autoSelected,
        compatibleLayouts:resolved.compatibleLayouts.map(x=>({key:x.key,label:x.label,widthBand:x.widthBand,heightBand:x.heightBand,baseListNet:x.baseListNet})),
        glass,glassLabel:glass==='satinato'?'10 mm ESG Satinato':'10 mm ESG klar',color,specialColor,
        baseListNet:resolved.baseListNet,baseEkNet,logisticsReserveNet:this.options.logisticsReserveNet,baseCustomerGross,
        areaSqm,satinatoGross,satinatoCostNet,specialColorGross,specialColorCostNet,
        accessories,accessoriesGross,accessoriesCostNet,totalCostNet,
        customerGross,customerNet,grossProfitNet,rawMarginPct,vatPct:this.options.vatPct,
        dealerDiscountPct:this.options.dealerDiscountPct,targetMarginPct:this.options.targetMarginPct
      };
    }
  }
  window.BEKSg23Engine=BEKSg23Engine;
})();
